import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Layout from './Layout';
import { SuperAdminHomePage } from 'pages/SuperAdmin/SuperAdminHomepage';
import SuperAdminSearchNetlinking from 'pages/SuperAdmin/SuperAdminSearchNetlinking';
import SuperAdminNetlinkingDetail from 'pages/SuperAdmin/SuperAdminNetlinkingDetail';
import SuperAdminUsersManagement from 'pages/SuperAdmin/SuperAdminUsersManagement';
import SuperAdminCreateWebsite from 'pages/SuperAdmin/SuperAdminCreateWebsite';
import SuperAdminFicheClient from 'pages/SuperAdmin/SuperAdminFicheClient';
import SuperAdminCreateCampaign from '../../pages/SuperAdmin/SuperAdminCreateCampaign';
import SuperAdminInProgressOrders from 'pages/SuperAdmin/SuperAdminInProgressOrders';
import SuperAdminCampaignDetail from '../../pages/SuperAdmin/SuperAdminCampaignDetail';
import SuperAdminUnassignedOrders from 'pages/SuperAdmin/SuperAdminUnassignedOrders';
import SuperAdminOverDueOrders from 'pages/SuperAdmin/SuperAdminOverDueOrders';
import SuperAdminProfile from 'pages/SuperAdmin/SuperAdminProfile';
import SuperAdminNetlinkingCreate from 'pages/SuperAdmin/SuperAdminCreateNetlinking';
import SuperAdminOrdersByWebsite from 'pages/SuperAdmin/SuperAdminOrdersByWebsite';
import SuperAdminCampaignSourcing from 'pages/SuperAdmin/SuperAdminCampaignSourcing';
import SuperAdminNetlinkingDetailShortcut from 'pages/SuperAdmin/SuperAdminNetlinkingDetailShortcut';
import SuperAdminDraftOrders from 'pages/SuperAdmin/SuperAdminDraftOrders';
import StillWorkingOnIt from './UnderConstruction';
import SuperAdminNotifications from 'pages/SuperAdmin/SuperAdminNotifications';
import SuperAdminOnlineOdrers from 'pages/SuperAdmin/SuperAdminOnlineOdrers';
import SuperAdminVueGlobale from 'pages/SuperAdmin/SuperAdminVueGlobale';
import VueRapport from 'components/Netlinking/Table/VueRapport'
export default class AdminMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Switch>
          <Route exact path="/SuperAdmin" component={SuperAdminHomePage} />
          <Route
            path="/SuperAdmin/SpotDetail"
            component={SuperAdminNetlinkingDetail}
          />
          <Route path="/SuperAdmin/Spot/Detail" component={SuperAdminNetlinkingDetailShortcut} />
          <Route path="/SuperAdmin/MonProfil" component={SuperAdminProfile} />
          <Route
            path="/SuperAdmin/ChercherSpot"
            component={SuperAdminSearchNetlinking}
          />
          <Route
            path="/SuperAdmin/CreerSpot"
            component={SuperAdminNetlinkingCreate}
          />

          <Route
            path="/SuperAdmin/GestionUtilisateur"
            component={SuperAdminUsersManagement}
          />
          <Route path="/SuperAdmin/MainMenu" component={SuperAdminHomePage} />
          <Route
            path="/SuperAdmin/AjouterClient"
            component={SuperAdminCreateWebsite}
          />
          <Route
            path="/SuperAdmin/AjouterCampaign"
            component={SuperAdminCreateCampaign}
          />
          <Route
            path="/SuperAdmin/FicheClient/:id"
            component={SuperAdminFicheClient}
          />
          <Route
            path="/SuperAdmin/CampagnesEnCour"
            component={SuperAdminInProgressOrders}
          />
          <Route
            path="/SuperAdmin/CampagnesEnRetard"
            component={SuperAdminOverDueOrders}
          />
          <Route
            path="/SuperAdmin/CampagnesNonAttribuees"
            component={SuperAdminUnassignedOrders}
          ></Route>
          <Route
            path="/SuperAdmin/DetailsCampagne/:id"
            component={SuperAdminCampaignDetail}
          />
          <Route
            path="/SuperAdmin/Website/:id/Campagnes"
            component={SuperAdminOrdersByWebsite}
          ></Route>
          <Route
            path="/SuperAdmin/Sourcing/Campaign/:id"
            component={SuperAdminCampaignSourcing}
          ></Route>

          <Route
            path="/SuperAdmin/CampagnesEnLigne"
            component={SuperAdminOnlineOdrers}
          ></Route>
          <Route
            path="/SuperAdmin/CampagnesEnBrouillon"
            component={SuperAdminDraftOrders}
          ></Route>

          <Route
            path="/SuperAdmin/Notifications"
            component={SuperAdminNotifications}
          ></Route>
          <Route
            path="/SuperAdmin/VueGlobale"
            component={SuperAdminVueGlobale}
          ></Route>
          <Route
            path="/SuperAdmin/VueRapport"
            component={VueRapport}
          ></Route>
        </Switch>
      </Layout>
    );
  }
}
